<template>
  <form v-on:submit.prevent="onSubmit">
    <div class="documentation__searchInput">
      <input type="search" v-model="search" placeholder="Hledat dle čísla konstrukce…"
             class="documentation__input"/>
      <button type="submit" class="documentation__button button view-primary-light">Vyhledat</button>
    </div>
  </form>
</template>

<script>
  export default {
    name:    'DownloadSearchInput',
    data() {
      return {
        search: this.getSearchString(),
      }
    },
    methods: {
      onSubmit() {
        this.$router.push({ name: 'download.search', query: { q: this.search } })
      },
      getSearchString() {
        return this.$route.query.q;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/download/SearchInput.vue